import React from "react";

const Step = ({ emoji, title, description }) => {
  return (
    <article className="w-[33%] max-md:ml-0 max-md:w-full">
      <div className="p-8 text-center">
        <div className="mb-6 text-5xl" aria-hidden="true">
          {emoji}
        </div>
        <h3 className="mb-4 text-2xl font-semibold">{title}</h3>
        <p className="leading-relaxed text-stone-500">{description}</p>
      </div>
    </article>
  );
};

const HowItWorksSection = () => {
  const steps = [
    {
      emoji: "🔗",
      title: "Connect your wallet",
      description: "No sign-ups. Just use your existing Ethereum wallet.",
    },
    {
      emoji: "💎",
      title: "Deposit ETH",
      description:
        "Your ETH is instantly diversified across a basket of top crypto assets.",
    },
    {
      emoji: "🎯",
      title: "Receive your index token",
      description:
        "This token represents your share of the entire portfolio — rebalance-ready and redeemable at any time.",
    },
  ];

  return (
    <section className="bg-white px-5 py-32">
      <div className="mx-auto my-0 max-w-[1200px]">
        <h2 className="mb-20 text-5xl font-bold text-center">How It Works</h2>
        <div className="flex gap-5 max-md:flex-col">
          {steps.map((step, index) => (
            <Step
              key={index}
              emoji={step.emoji}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
